
export default function AboutSection() {
  const expertise = [
    {
      icon: 'ri-user-heart-line',
      title: 'User-Centered Design',
      description: 'Deep understanding of user needs through comprehensive research and testing methodologies.'
    },
    {
      icon: 'ri-building-line',
      title: 'Enterprise Solutions',
      description: 'Specialized in complex enterprise software and large-scale digital transformation projects.'
    },
    {
      icon: 'ri-palette-line',
      title: 'Design Systems',
      description: 'Creating scalable design systems that ensure consistency across all digital touchpoints.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Innovation Focus',
      description: 'Leveraging cutting-edge design trends and technologies to deliver future-ready solutions.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Crafting Digital Experiences That 
              <span className="text-blue-600"> Drive Results</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              At JB Technologies, we believe that exceptional user experience is the cornerstone of digital success. 
              With over 8 years of experience across diverse industries, we've mastered the art of translating 
              complex business requirements into intuitive, user-friendly solutions.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Our multidisciplinary approach combines strategic thinking, creative design, and technical expertise 
              to deliver solutions that not only meet user needs but exceed business expectations.
            </p>
            
            <div className="flex items-center space-x-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600">150+</div>
                <div className="text-sm text-gray-500">Projects</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600">12+</div>
                <div className="text-sm text-gray-500">Industries</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600">98%</div>
                <div className="text-sm text-gray-500">Success Rate</div>
              </div>
            </div>
          </div>
          
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/30a9098c5e2cbcbc40240a8bf2f45522.jpg"
              alt="UX Design Process"
              className="rounded-2xl shadow-2xl object-cover w-full h-96"
            />
          </div>
        </div>
        
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">Our Expertise</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {expertise.map((item, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${item.icon} text-2xl text-blue-600`}></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-4">{item.title}</h4>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
